<template>
    <div class="modal-header">
        <slot></slot>
    </div>  
</template>
